<template>
  <div class="bg-F6F6F6 w-fullVw fb fb-col">
    <div
      class="bg-FFFFFF font-28 fb fb-cross-center fb-main-between p-0-16 bb h-48"
    >
      <div class="fb fb-cross-center fb-main-between w-150">
        <span @click="fetchGetStudentMonthRecord(-1)">
          <i class="iconfont font-48 c-171A1D-40">&#xe67e;</i>
        </span>
        <span>{{ computedSelectTime }}</span>
        <span @click="fetchGetStudentMonthRecord(1)"
          ><i class="iconfont c-171A1D-40 font-32">&#xe66b;</i>
        </span>
      </div>
      <div class="fb fb-cross-center" @click="handlerCalendarOrMonth">
        <span class="iconfont font-32 mr-4">&#xe684;</span>
        <span class="font-28">打卡月历</span>
      </div>
    </div>

    <md-tabbar
      v-model="tabIndex"
      :fixed="tabList.length < 4"
      class="mb-12"
      indicatorColor="#171A1D"
    >
      <md-tabbar-item v-for="item in tabList" :key="item.id" :name="item.id">
        {{ item.name }}({{ list[item.countText] || 0 }})
      </md-tabbar-item>
    </md-tabbar>

    <div class="item-flex-1 scroll-y" v-if="detailList && detailList.length">
      <div
        v-for="(item, index) in detailList"
        :key="index"
        class="w-fullVw bg-FFFFFF p-0-16"
      >
        <div
          class="fb fb-cross-center fb-main-between h-56"
          :class="{ bt: index !== 0 }"
          @click="handlerDetailItem(item)"
        >
          <div
            class="font-30"
            :class="{ 'text-ellipsis w-220': +tabIndex !== 0 }"
          >
            {{ item.time }}
          </div>
          <div :class="[item.color, 'font-26']">
            {{ item.status }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="relative h-340">
      <common-no-data class="common-no-record">
        <div class="no-item"></div>
        <p class="font-28 c-171A1D-40">暂无记录</p>
      </common-no-data>
    </div>
  </div>
</template>
<script>
import API from '../api'
import {
  mcShowPreloader,
  mcHidePreloader,
  mcSetTitle
} from '@/utils/mcSdkUtils'
import {
  monthDay,
  toDateArr,
  unitDayTime,
  isWxPlatform
} from '@/utils/comUtils'
import { WEEK_DAY_FULL, ATTENDANCE_ATATUS } from '@/utils/constUtils'
import commonNoData from './commonNoData'
export default {
  components: { commonNoData },
  props: {
    student: {
      // 学生信息
      type: Object,
      default: () => {
        return {}
      }
    },
    // 标签信息
    tabList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      list: [],
      /* eslint-disable */
      yearMonth: (function () {
        let year = new Date().getFullYear()
        let month = new Date().getMonth() + 1
        if (month < 10) {
          month = '0' + month
        }
        return `${year}${month}`
      })(),
      /* eslint-enable */
      oldTimeOut: 0,
      detailList: [],
      tabIndex: +this.tabList[0].id,
      year: new Date().getFullYear(),
      month: `0${new Date().getMonth() + 1}`.slice(-2),
      isWxPlatform: isWxPlatform()
    }
  },
  computed: {
    // 展示年月
    computedSelectTime() {
      let year = this.yearMonth.slice(0, 4)
      let month = this.yearMonth.slice(4, 6)
      return `${year}年${month}月`
    }
  },
  watch: {
    student: {
      immediate: true,
      handler() {
        this.yearMonth = (this.student.date || '').slice(0, 6) || this.yearMonth
        this.fetchGetStudentMonthRecord()
      },
      deep: true
    },
    computedSelectTime(val) {
      if (val.slice(5, 7) !== this.student.date.slice(4, 6)) {
        this.$emit('change', `${val.slice(0, 4)}${val.slice(5, 7)}`)
      }
    },
    tabIndex(val) {
      this.handlerChangeState(this.tabList.find(item => +item.id === +val))
    }
  },
  methods: {
    // 切换状态
    handlerChangeState(state) {
      mcShowPreloader()
      setTimeout(() => {
        mcHidePreloader()
      }, 3000)
      this.tabIndex = +state.id
      let _params = {
        dingUserId: this.student.tpId,
        dingDeptIds: this.student.tpClassId,
        timeStart: `${this.yearMonth}01`,
        timeEnd: this.getMonthEndDate(),
        checkInStateCT: state.eq || (+state.id === 5 ? 'neq' : 'eq'),
        checkInState: state.id,
        leaveType: 1, //  1病假 2事假
        inOutType: 1, // 上下学:1 上学 2下学
        pageNum: 1,
        pageSize: 1000
      }
      switch (`${state.id}`) {
        // 服务端定义为缺勤 暂未找到使用处
        case '5':
          API.getUserDayAttendanceStat(_params)
            .then(res => {
              this.detailList = []
              ;(res || []).forEach(item => {
                let record = {
                  time: this.handlerTransformTime(item.dayTime),
                  status: this.handlerTransformStatus(item.checkInStates)
                }
                record.color = !record.status.includes('正常')
                  ? 'c-F25643'
                  : 'c-006AFE'
                this.detailList.push(record)
              })
            })
            .catch(err => {
              console.log('unhandledrejection', err)
            })
            .finally(() => {
              mcHidePreloader()
            })
          break
        default:
          API.getDeptLLLDailyStates(_params)
            .then(res => {
              this.detailList = []
              ;(res || []).forEach(item => {
                item.time = this.methodTransforTime(item.dayTime) || ''
                item.color = 'c-171A1D-40'
                switch (`${state.id}`) {
                  case '0':
                    item.status = ``
                    break
                  case '3':
                    item.status = `上学迟到${item.periodMinutes || ''}分钟`
                    break
                  case '6':
                    if (+item.leaveDurationUnit === 2) {
                      let _unitDayTime = unitDayTime(
                        +item.leaveStartTime,
                        +item.leaveEndTime,
                        'YYYY.MM.DD'
                      )
                      item.time = `${_unitDayTime[0]}～${_unitDayTime[1]}`
                      item.status = `请假${(
                        (item.leaveEndTime - item.leaveStartTime) /
                        (24 * 60 * 60 * 1000)
                      ).toFixed(1)}天`
                    } else {
                      item.time = `${this.methodTimeForm(
                        item.leaveStartTime
                      )}～${this.methodTimeForm(item.leaveEndTime)}`
                      item.status = this.methodHour(item.periodMinutes)
                    }
                    // item.dingLeaveUrl = item.dingLeaveUrl
                    break
                }
                this.detailList.push(item)
              })
            })
            .catch(err => {
              console.log('unhandledrejection', err)
            })
            .finally(() => {
              mcHidePreloader()
            })
      }
    },
    handlerTransformTime(time) {
      let date = new Date(Number(time))
      let year = date.getFullYear()
      let month = this.handlerAddZero(date.getMonth() + 1)
      let day = this.handlerAddZero(date.getDate())
      let week = WEEK_DAY_FULL[date.getDay()]
      return `${year}.${month}.${day}\xa0\xa0${week}`
    },
    handlerTransformStatus(status) {
      let resultStatus = status.reduce((total, currentStatus, index, arr) => {
        total = total + ATTENDANCE_ATATUS[currentStatus + 1] + ','
        return total
      }, '')
      return resultStatus.substring(0, resultStatus.length - 1)
    },
    handlerAddZero(ele) {
      if (ele < 10) {
        ele = '0' + ele
      }
      return ele
    },
    // 跳转详情
    handlerDetailItem(date) {
      let _time = date.time.replace(/\s+.*/, '')
      switch (`${this.tabIndex}`) {
        case '0':
          this.$emit('methodGetDetailCalendar', _time)
          break
        case '3':
          this.$emit('methodGetDetailCalendar', _time)
          break
        case '5':
          this.$emit('methodGetDetailCalendar', _time)
          // let time =
          //   date.time.slice(0, 4) +
          //   date.time.slice(5, 7) +
          //   date.time.slice(8, 10)
          // this.$store.commit('calendarTime', time)
          // this.$store.commit('isCalendarForm', null)
          break
        case '6':
          this.$router.push({
            path: '/leave/detail',
            query: {
              leaveId: date.leaveId
            }
          })
          break
      }
    },
    fetchGetStudentMonthRecord(direction) {
      if (direction) {
        let time = new Date(
          `${this.yearMonth.slice(0, 4)}/${this.yearMonth.slice(4, 6)}/01 00:00`
        )
        time.setMonth(time.getMonth() + direction)
        let year = time.getFullYear()
        let month = `0${time.getMonth() + 1}`.slice(-2)
        let _yearMonth = `${year}${month}`
        if (
          _yearMonth < `${this.year - 1}${this.month}` ||
          _yearMonth > `${this.year}${this.month}`
        ) {
          return false
        }
        this.yearMonth = `${year}${month}`
      }
      API.attendanceStudentMonth({
        month: this.yearMonth,
        dingUserId: this.student.tpId,
        dingDeptId: this.student.tpClassId
      })
        .then(res => {
          this.list = res[0] || {}
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
      this.handlerChangeState({ id: this.tabIndex })
    },
    // 选择个人月统计和打卡日历
    handlerCalendarOrMonth() {
      this.$store.commit('isCalendarForm', !this.$store.getters.isCalendarForm)
      if (this.$store.getters.isCalendarForm) {
        mcSetTitle('个人月统计')
      } else {
        mcSetTitle('考勤记录')
      }
    },
    // 月统计结束日期
    getMonthEndDate() {
      let _time = toDateArr(this.computedSelectTime)
      let _timeEnd = monthDay(_time[1], _time[2])
      return _timeEnd
    },
    // 时间计算
    methodHour(time) {
      let _time = ''
      if (time > 60) {
        const _HOURS = (time / 60).toFixed(1)
        _time = `请假${_HOURS}小时`
      } else {
        _time = `请假${time}分钟`
      }
      return _time
    },
    // 格式化时间
    methodTimeForm(time) {
      let date = new Date(Number(time))
      let year = date.getFullYear()
      let month = this.methodAddZero(date.getMonth() + 1)
      let day = this.methodAddZero(date.getDate())
      return `${year}.${month}.${day}`
    },
    methodTransforTime(time) {
      let date = new Date(Number(time))
      let year = date.getFullYear()
      let month = this.methodAddZero(date.getMonth() + 1)
      let day = this.methodAddZero(date.getDate())
      let hour = this.methodAddZero(date.getHours())
      let min = this.methodAddZero(date.getMinutes())
      let week = WEEK_DAY_FULL[date.getDay()]
      return `${year}.${month}.${day}\xa0\xa0${week}\xa0\xa0\xa0\xa0(${hour}:${min})`
    },
    methodAddZero(ele) {
      if (ele < 10) {
        ele = '0' + ele
      }
      return ele
    }
  },
  mounted() {
    // Object.keys(this.student).length &&
    //   (this.yearMonth = this.student.date.slice(0, 6) || this.yearMonth) &&
    //   this.fetchGetStudentMonthRecord()
    // this.handlerChangeState({ id: this.tabIndex })
  }
}
</script>
<style lang="scss" scoped>
.no-data {
  .no-item {
    width: 180px;
    height: 180px;
    background: url(~@/assets/images/no-data.png) no-repeat center top;
    background-size: 180px 180px;
  }
}
</style>
